'use client';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { convertUploadUrl } from '@/lib/upload-utils';

interface UploadAvatarProps {
  src: string | null | undefined;
  alt: string;
  fallback: string;
  className?: string;
  fallbackStyle?: React.CSSProperties;
}

/**
 * Enhanced Avatar component that automatically converts upload URLs for production compatibility
 */
export const UploadAvatar = ({
  src,
  alt,
  fallback,
  className,
  fallbackStyle
}: UploadAvatarProps) => {
  const convertedSrc = convertUploadUrl(src);

  return (
    <Avatar className={className}>
      {convertedSrc && <AvatarImage alt={alt} src={convertedSrc} className='object-cover' />}
      <AvatarFallback style={fallbackStyle}>{fallback}</AvatarFallback>
    </Avatar>
  );
};
